import { Checkbox, CheckboxGroup, Stack } from '@agrotoken-tech/ui';
import { useTranslation } from '@bcba/react-hooks';
import { DIGITAL_DOSSIER_SECTIONS, DigitalDossierSection } from '@bcba/types';
import React from 'react';

export const AccessibleSectionCheckboxGroup = (props: {
  accessibleSections: DigitalDossierSection[];
  handleChangeAccessibleSections: (sections: DigitalDossierSection[]) => void;
}) => {
  const { t } = useTranslation();
  const { accessibleSections, handleChangeAccessibleSections } = props;

  return (
    <CheckboxGroup
      defaultValue={accessibleSections}
      onChange={handleChangeAccessibleSections}
    >
      <Stack mt={8}>
        <Checkbox
          size="sm"
          value={DIGITAL_DOSSIER_SECTIONS.DECLARED_JURISDICTIONS}
        >
          {t('accessibleSection.DECLARED_JURISDICTIONS')}
        </Checkbox>
        <Checkbox size="sm" value={DIGITAL_DOSSIER_SECTIONS.ASSET_INFORMATION}>
          {t('accessibleSection.ASSET_INFORMATION')}
        </Checkbox>
      </Stack>
    </CheckboxGroup>
  );
};

export default AccessibleSectionCheckboxGroup;
